/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Subtotalsbystage3Inputs */

const en_coinvestments_tracking_subtotalsbystage3 = /** @type {(inputs: Coinvestments_Tracking_Subtotalsbystage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtotals by Stage`)
};

/**
* | output |
* | --- |
* | "Subtotals by Stage" |
*
* @param {Coinvestments_Tracking_Subtotalsbystage3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_subtotalsbystage3 = /** @type {((inputs?: Coinvestments_Tracking_Subtotalsbystage3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Subtotalsbystage3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_subtotalsbystage3(inputs)
});
export { coinvestments_tracking_subtotalsbystage3 as "coInvestments_tracking_subtotalsByStage" }